import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const VideoWrapper = styled.div`
  margin: auto;
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 60%;
  }
`;

export const VideoDescription = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    text-align: left;
  }

  p {
    font-size: 1rem;
    line-height: 1.5rem;
    margin: 0 auto;

    @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
      font-size: 1.5rem;
      line-height: 2.25rem;
    }
  }
`;

export const VideoHeader = styled.h2`
  font-size: 1.5rem;
  line-height: 1.95rem;
  margin-top: 0.75rem;
  text-align: center;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin-top: unset;
    font-size: 2.5rem;
    line-height: 3.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    text-align: left;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  margin-bottom: 1.25rem;
  flex-direction: column-reverse;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    gap: 1.5rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin-bottom: 2rem;
    flex-direction: row;

    &.content-reverse {
      flex-direction: row-reverse;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: auto;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: 40%;
  }
`;

export const StyledCtas = styled(Ctas)`
  margin: 0.75rem auto;

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    margin: 1.5rem 0;
  }
`;
